const Module = () => import('./Module.vue')
const Home = () => import('./views/Home.vue')

const moduleRoute = {
  path: '/archive',
  component: Module,
  children: [
    {
      path: '/',
      name: 'archive-home',
      component: Home,
    },
  ],
}

export default router => {
  router.addRoutes([moduleRoute])
}
